import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { Button } from '@monorepo/shared/componentsV2/Button';
import { Tooltip } from '@monorepo/shared/componentsV2/Tooltip';
import React, { useCallback } from 'react';
import styled from 'styled-components';
import { ConditionallyShownFieldInfo } from './types';

const EMPTY_CONDITIONALLY_SHOWN_FIELD: ConditionallyShownFieldInfo = {
  hideInPdfIfConditionallyHidden: false,
  id: '',
};

const StyledButton = styled(Button)`
  margin-top: 0.2rem;

  &.Mui-disabled:focus {
    color: ${({ theme }) => theme.colors.gray999};
  }
`;

interface AddConditionallyShownFieldButtonProps {
  addConditionallyShownField: (
    conditionallyShownField: ConditionallyShownFieldInfo,
  ) => void;
  canAddConditionallyShownField: boolean;
  focusCatcherRef: React.RefObject<HTMLButtonElement>;
}

export function AddConditionallyShownFieldButton({
  focusCatcherRef,
  addConditionallyShownField,
  canAddConditionallyShownField,
}: AddConditionallyShownFieldButtonProps) {
  const addEmptyConditionallyShownField = useCallback(() => {
    addConditionallyShownField(EMPTY_CONDITIONALLY_SHOWN_FIELD);
  }, [addConditionallyShownField]);

  const isDisabled = !canAddConditionallyShownField;

  return (
    <Tooltip
      title={
        isDisabled
          ? 'There are no more available fields left that are not already conditionally shown.'
          : ''
      }
    >
      <span>
        <StyledButton
          ref={focusCatcherRef}
          color="primary"
          onClick={addEmptyConditionallyShownField}
          disabled={isDisabled}
          focusableWhenDisabled
        >
          <AddCircleOutlineIcon aria-hidden />
          Add another field
        </StyledButton>
      </span>
    </Tooltip>
  );
}
